import React from "react";
import ContentCard from "@/components/ContentCard";
import PageLayout from "@/components/PageLayout";

const PrintProfiles = () => {
  return (
    <PageLayout
      title="Print Profiles"
      description="Skadisfinity uses print profiles to match different printable Skadis board sizing systems."
    >
      <ContentCard title="Default Profile">
        <p>
          The Default profile treats 240mm by 240mm as the standard full board
          size. It is intended for builders who want straightforward
          millimeter-based board labels and predictable full-board placement.
        </p>
        <p>
          Use this profile when you are working from standard Skadisfinity board
          dimensions or when you want the results to emphasize physical
          millimeter sizes over hole-count labels.
        </p>
      </ContentCard>

      <ContentCard title="AU3D Profile">
        <p>
          The AU3D profile follows the 20mm increment sizing table used by AU3D
          style Skadis boards. In this profile, a 240mm by 240mm board displays
          as 11 x 11 because that is the matching hole-count label from the size
          chart.
        </p>
        <p>
          This profile can select combinations such as 100mm by 240mm edge
          pieces when that reduces spacer waste and fills more of the requested
          layout. It is useful when you want the preview to match AU3D-style
          row and column labels.
        </p>
      </ContentCard>

      <ContentCard title="Which Profile Should You Use?">
        <p>
          Use the profile that matches the board files or design system you
          plan to print. If both profiles are available for your project, compare
          the trim values and preview. The better choice is usually the one that
          fills the target space with less spacer area while still using pieces
          your printer can produce reliably.
        </p>
      </ContentCard>
    </PageLayout>
  );
};

export default PrintProfiles;
